import { AppContainerProps, AppConfigPropsType } from "./types"
import { defaultReferral, getUrlQuery } from "./utils"

export const get_faker_config = (): AppConfigPropsType => {
    return {
        CaptchaSiteKey: '',
        ContactFieldGroups: [
            {
                group_id: "1",
                fields: [
                    {
                        id: 'companyName',
                        name: 'companyName',
                        label: 'Company Name',
                        type: 'text',
                        required: true,
                    },
                    {
                        id: 'companyAddress',
                        name: 'companyAddress',
                        type: 'text',
                        label: 'Company Address',
                        required: true,
                    },
                    {
                        id: 'companyCity',
                        name: 'companyCity',
                        type: 'text',
                        label: 'Company City',
                        required: true,
                    },
                    {
                        id: 'companyState',
                        name: 'companyState',
                        type: 'text',
                        label: 'Company State',
                        required: true,
                    },
                    {
                        id: 'companyZip',
                        name: 'companyZip',
                        type: 'text',
                        label: 'Company Zip',
                        required: true,
                    },
                ],
            },
            {
                group_id: "2",
                fields: [
                    {
                        id: 'firstName',
                        name: 'firstName',
                        label: 'First Name',
                        type: 'text',
                        required: true,
                    },
                    {
                        id: 'lastName',
                        name: 'lastName',
                        type: 'text',
                        label: 'Last Name',
                        required: true,
                    },
                    {
                        id: 'email',
                        name: 'email',
                        type: 'email',
                        label: 'Email',
                        required: true,
                    },
                    {
                        id: 'phone',
                        name: 'phone',
                        type: 'phone',
                        label: 'Phone',
                        required: false,
                    },
                ],
            },
        ],
        Questions: [
            {
                question_id: "1",
                question: "Do you have an IT Service Provider that manages your systems?",
                answers: [
                    "Yes", "No",
                ],
            },
            {
                question_id: "2",
                question: "Do you have a policy that directs that appropriate system and application logs are collected, protected, and reviewed for problems or abnormal behavior?",
                answers: [
                    "Yes", "No",
                ],
            },
            {
                question_id: "3",
                question: "Do you have a policy to configure all printers and computers with only the capabilities they need?",
                answers: [
                    "Yes", "No",
                ],
            },
            {
                question_id: "4",
                question: "Do you have a business continuity and disaster recovery plan to ensure resilience in adverse situations?",
                answers: [
                    "Yes", "No",
                ],
                follow_up_questions: [
                    {
                        question_id: "5",
                        question: "If so, do you test these plans at least annually?",
                        answers: [
                            "Yes", "No",
                        ],
                        conditional_answers: ["Yes"],
                    },
                ]
            },
            {
                question_id: "6",
                question: "Do you have a policy to monitor your network and computer systems and respond to any detected events?",
                answers: [
                    "Yes", "No",
                ],
            },
            {
                question_id: "7",
                question: "Do you have an inventory of what software and hardware you use?",
                answers: [
                    "Yes", "No",
                ],
            },
            {
                question_id: "8",
                question: "Do you encrypt sensitive information on your systems when it is not in use (at rest)?",
                answers: [
                    "Yes", "No",
                ],
            },
            {
                question_id: "9",
                question: "Do you require that all traffic to/from the internet use SSL/TLS?",
                answers: [
                    "Yes", "No",
                ],
            },
            {
                question_id: "10",
                question: "Do you have all information sent to outside parties reviewed for sensitive information (e.g., NPI) and encrypted if necessary?",
                answers: [
                    "Yes", "No",
                ],
            },
            {
                question_id: "11",
                question: "Do you periodically backup your data?",
                answers: [
                    "Yes", "No",
                ],
            },
            {
                question_id: "12",
                question: "Do you keep a copy of your backup at a secure off-site location that cannot be accessed normally?",
                answers: [
                    "Yes", "No",
                ],
            },
            {
                question_id: "13",
                question: "Do you have a policy that provides instructions on how to destroy data (paper and digital)?",
                answers: [
                    "Yes", "No",
                ],
            },
            {
                question_id: "14",
                question: "Do you have a policy that provides instructions on safely disposing of old or surplus computers, phones, and printers?",
                answers: [
                    "Yes", "No",
                ],
            },
            {
                question_id: "15",
                question: "Do you require that everyone that access your systems and data have a unique username and password?",
                answers: [
                    "Yes", "No",
                ],
            },
            {
                question_id: "16",
                question: "Do you periodically review who has access to your systems and applications?",
                answers: [
                    "Yes", "No",
                ],
            },
            {
                question_id: "17",
                question: "Do you have procedures in place to encrypt emails that contain sensitive information?",
                answers: [
                    "Yes", "No",
                ],
            },
            {
                question_id: "18",
                question: "Do you require multi-factor authentication for systems that are accessed remotely?",
                answers: [
                    "Yes", "No",
                ],
            },
            {
                question_id: "19",
                question: "Are Legal and regulatory requirements regarding cybersecurity, including privacy and civil liberties obligations, understood and managed?",
                answers: [
                    "Yes", "No",
                ],
            },
            {
                question_id: "20",
                question: "Are all users informed about cyber security and periodically trained?",
                answers: [
                    "Yes", "No",
                ],
                follow_up_questions: [
                    {
                        question_id: "21",
                        question: "How often are users trained?",
                        answers: [
                            "Monthly", "Quarterly", "Annually",
                        ],
                        conditional_answers: ["Yes"],
                    },
                ]
            },
            {
                question_id: "22",
                question: "Do you use a Phishing simulation program to send realistic phishing emails to employees to gauge their awareness of attacks?",
                answers: [
                    "Yes", "No",
                ],
                follow_up_questions: [
                    {
                        question_id: "23",
                        question: "How often are simulated emails sent?",
                        answers: [
                            "Monthly", "Quarterly", "Annually",
                        ],
                        conditional_answers: ["Yes"],
                    },
                ]
            },
            {
                question_id: "24",
                question: "Do users who have administrative access to systems understand their roles and their responsibilities?",
                answers: [
                    "Yes", "No",
                ],
            },
            {
                question_id: "25",
                question: "Have you defined critical cyber risks to your business?",
                answers: [
                    "Yes", "No",
                ],
            },
            {
                question_id: "26",
                question: "Have you defined resiliency requirements for critical systems or services?",
                answers: [
                    "Yes", "No",
                ],
            },
            {
                question_id: "27",
                question: "Do you have response plans for cyber incidents and business continuity in place?",
                answers: [
                    "Yes", "No",
                ],
                follow_up_questions: [
                    {
                        question_id: "28",
                        question: "How often are these plans reviewed?",
                        answers: [
                            "Monthly", "Quarterly", "Annually",
                        ],
                        conditional_answers: ["Yes"],
                    },
                ]
            },
            {
                question_id: "29",
                question: "Do you maintain a list of all your third-party partners that supply information systems components and services?",
                answers: [
                    "Yes", "No",
                ],
                follow_up_questions: [
                    {
                        question_id: "30",
                        question: "And have you assessed their risk to your business?",
                        answers: [
                            "Yes", "No",
                        ],
                        conditional_answers: ["Yes", "No"],
                    },
                ]
            },
        ],
        DisplayAsModal: true,
        AutoNext: true,
        ModalButtonText: 'Get Started',
        Theme: {
            HighlightColor: '#006BB3',
            ContrastColor: '#fff',
        },
        Referral: getUrlQuery('referral') || defaultReferral,
    }
}

export const get_app_config = (): AppContainerProps => {
    let api_endpoint = ((window as any).ajax_object?.survey_api || null)
    let config = {
        DisplayAsModal: true,
        AutoNext: true,
        ModalButtonText: 'Get Started',
        Theme: {
            HighlightColor: '#006BB3',
            ContrastColor: '#fff',
        },
    } as AppConfigPropsType

    if (api_endpoint === null && (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test')) {
        config = get_faker_config()
        api_endpoint = process.env.REACT_APP_WP_JSON_ENDPOINT ? '/wfg/v1/survey' : null
    }

    return {
        config,
        api_endpoint,
        selected_answers: [],
    }
}
